export const UPDATE_CARER_PATH_DATA: string = 'UPDATE_CARER_PATH_DATA';
